import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


//import ExpandableNavItem from "components/ExpandableNavItem";
import NavItem from "components/NavItem";

export default function MainMenu({ menuLayout, closeMenuHandler }) {
  let location = useLocation();
  useEffect(() => {
    closeMenuHandler && closeMenuHandler();
  }, [location, closeMenuHandler]);

  return (
    <>
      {/* <li className="nav-item">
        <a
          className="nav-link jumpapp"
          href="https://war-bi.qnalytics.com/"
          target="_blank"
          rel="noreferrer"
        >
          <i className="lui-icon  lui-icon--log-in"></i>
          <p>{menuLayout.MenuItem27}</p>
        </a>
      </li> */}
      <NavItem
        to="/"
        text={menuLayout.MenuItem1}
        icon={<FontAwesomeIcon icon="home" />}
        //icon="nav-icon fas fa-home"
      />
      <NavItem
        to="/completedRoutes"
        text={menuLayout.MenuItem4}
        icon={<FontAwesomeIcon icon="route" />} //"nav-icon fas fa-money-check"
      />
{/*       <NavItem
        to="/destinations"
        text={menuLayout.MenuItem2}
        icon={<FontAwesomeIcon icon="bus" />} //"nav-icon fas fa-money-check"
      />
      <NavItem
        to="/details"
        text={menuLayout.MenuItem3}
        icon={<FontAwesomeIcon icon="list" />}
      /> */}
      <NavItem
        to="/licensing"
        text={menuLayout.MenuItem5}
        icon={<FontAwesomeIcon icon="id-card" />}
      />
{/*       <NavItem
        to="/selections"
        text={menuLayout.MenuItem8}
        //icon="nav-icon fas fa-industry"
        icon={<FontAwesomeIcon icon="filter" />}
      /> */}
      {/* <div className="col-12 as-of-date-disclaimer">
        <p>
        {menuLayout.KPIsAsOfDate}
        </p>
      </div> */}
    </>
  );
}
